import gql from "graphql-tag";

const queryCreateDocumentType = gql`
  mutation($code: String!, $title: String!) {
    createDocumentType(data: { code: $code, title: $title }) {
      id
      code
      title
      updatedAt
      createdAt
    }
  }
`;

const queryUpdateDocumentType = gql`
  mutation($code: String!, $title: String!, $id: ID!) {
    updateDocumentType(id: $id, data: { code: $code, title: $title }) {
      id
      code
      title
      updatedAt
      createdAt
    }
  }
`;

const queryDeleteDocumentType = gql`
  mutation($id: ID!) {
    deleteDocumentType(id: $id) {
      id
    }
  }
`;

export default {
  queryCreateDocumentType,
  queryUpdateDocumentType,
  queryDeleteDocumentType,
};
